//STEP 1. Import Necessary indicator or rather last step
import { LinkedList } from '../Utils/LinkedList';
import { Indicator, IndicatorInput } from '../indicator/indicator';
//STEP 2. Create the input for the indicator, mandatory should be in the constructor
export class VWMAInput extends IndicatorInput {
}
;
//STEP3. Add class based syntax with export
export class VWMA extends Indicator {
    constructor(input) {
        super(input);
        this.period = input.period;
        this.price = input.closes;
        this.volume = input.volumes;
        if (!((input.closes.length === input.volumes.length))) {
            throw ('Inputs(close , volume) not of equal size');
        }
        var genFn = (function* (period) {
            var listPrice = new LinkedList();
            var listVolume = new LinkedList();
            var sumPrice = 0;
            var sumVolume = 0;
            var counter = 1;
            var current = yield;
            var result;
            listPrice.push(0);
            listVolume.push(0);
            while (true) {
                if (counter < period) {
                    counter++;
                    listPrice.push(current.close * current.volume);
                    listVolume.push(current.volume);
                    sumPrice = sumPrice + (current.close * current.volume);
                    sumVolume = sumVolume + current.volume;
                }
                else {
                    sumPrice = sumPrice - listPrice.shift() + (current.close * current.volume);
                    sumVolume = sumVolume - listVolume.shift() + current.volume;
                    result = ((sumPrice) / sumVolume);
                    listPrice.push(current.close * current.volume);
                    listVolume.push(current.volume);
                }
                current = yield result;
            }
        });
        this.generator = genFn(this.period);
        this.generator.next();
        this.result = [];
        this.price.forEach((tick, index) => {
            var result = this.generator.next({
                close: this.price[index],
                volume: this.volume[index]
            });
            if (result.value != undefined) {
                this.result.push(result.value);
            }
        });
    }
    nextValue(price) {
        var result = this.generator.next(price).value;
        if (result != undefined)
            return this.format(result);
    }
    ;
}
VWMA.calculate = vwma;
export function vwma(input) {
    Indicator.reverseInputs(input);
    var result = new VWMA(input).result;
    if (input.reversedInput) {
        result.reverse();
    }
    Indicator.reverseInputs(input);
    return result;
}
;
//STEP 6. Run the tests
